import { defineStyleConfig } from '@chakra-ui/styled-system'

export const formLegendTheme = defineStyleConfig({
  baseStyle: {
    fontWeight: 'semibold',
    mb: 4,
  },
})
